const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projectTermJobs',
        showHead: true,
        // showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            advertisement: true,
            customerMaxPrice: true,
            skills: true,
            infoInternal: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'advertise',
                // },
                {
                    buttonType: 'delete',
                    neutral: true,
                }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_jobs': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_projectTermJobStatus': true
        },
    },

    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
        resourceFilters: {
            order: [{
                fieldCode: 'startTS',
                direction: 'asc'
            },{
                fieldCode: 'projectTermJobID',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_projectTermJobs:create', mode: 'mass', },
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_projectTermJobs:create' }
                ]
            }
        },

        showInsert(buttonContext, buttonMode){
            let projectTermPropertiesForm
            this.locate('< templates_core_controller_controller > templates_customers_projectTerms_propertiesForm', c => projectTermPropertiesForm = c)

            if(!projectTermPropertiesForm){
                this.locate('< base_form_form', c => projectTermPropertiesForm = c)
            }
            if(!projectTermPropertiesForm){
                return
            }

            const startTS = projectTermPropertiesForm.getFieldValue('startTS', 'live')
            const endTS = projectTermPropertiesForm.getFieldValue('endTS', 'live')
            this.model.controller.showInsert(buttonContext, buttonMode, {
                source: {
                    load: {
                        componentData: {
                            actions: {
                                loadContent: {
                                    source: {
                                        load: {
                                            componentData: {
                                                model: {
                                                    dirtyFields: {
                                                        data: {
                                                            attributes: {
                                                                startTS,
                                                                endTS,
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }, {
                fieldConfig: {
                    showOnCustomerOrderMandatory: true,
                }
            })
        },

        // TODO: within customers?? advertise??
        async advertise(entityID, entityData){
            if(entityID){
                const isAdvertised = (entityData.attributes || {}).isAdvertised

                if(isAdvertised){
                    return this.performAction(
                        this.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:advertiseProjectTermJob.alreadyDone'
                            }
                        })
                    )
                } else {
                    await this.performAction(this.prepareAction('edit_projectTermJob', entityID, undefined, {
                        source: {
                            submit: {
                                data: {
                                    data: {
                                        attributes: {
                                            isAdvertised: true,
                                            isAdvertisedAt: new Date().toISOString()
                                        }
                                    }
                                }
                            }
                        }
                    }))

                    this.refreshData()
                }
            }
        },

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                this.refresh(false)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(utils.isEmpty(this.model.projectMeta)){
                this.locate('< base_tabStrip_tabStrip > templates_customers_projectTerms_controller', controller => {
                    this.model.projectMeta = {
                        ...(controller.model.projectMeta || {})
                    }
                })
            }

            if(!this.config.customHeadActionsFormMappingBackup){
                this.config.customHeadActionsFormMappingBackup = {
                    ...(this.config.customHeadActionsFormMapping || {})
                }
            }
            if(!this.config.rowActionsBackup){
                this.config.rowActionsBackup = {
                    ...(this.config.rowActions || {})
                }
            }

            const projectTermID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectTermID
            const grantedChanges = (((this.model.projectMeta || {}).grantedChanges || {}).projectTerms || {})[projectTermID] || {}

            if(grantedChanges.major){
                this.config.customHeadActionsFormMapping = {
                    ...(this.config.customHeadActionsFormMappingBackup || {})
                }
                this.config.rowActions = {
                    ...(this.config.rowActionsBackup || {})
                }
            } else {
                this.config.customHeadActionsFormMapping = {}
                this.config.rowActions.customs = []
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const baseFilters = (this.model.parentEntityForTable || {}).baseFilters || {}

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTermJobs' &&
                    key !== 'resourceChanged.bo_projectTermJobStatus' &&
                    key !== 'resourceChanged.bo_status'
                ) ||
                message.data.projectTermID == baseFilters.projectTermID ||
                (message.data.projectTermIDs || {})[baseFilters.projectTermID] ||
                (key === 'resourceChanged.bo_status' && this.isAtLeastOneStatusIDLoaded(message.data.statusIDs))
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}